import { Row, Divider } from "antd";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";

import get from "lodash/get";
import slice from "lodash/slice";
import round from "lodash/round";
import sortBy from "lodash/sortBy";

import GraphHeader from "./graphHeader";
import GraphGrid from "../graphGrid";


import { getTransformedMinutes } from "../../../utilities/helpers";
import { fetchScopeNodeHierarchy } from "../../../redux/actions/locationActions";

const CNCGraphSection = ({
  selectedTemplate,
  onChangeParams,
  filter,
  setLoading,
}) => {
  const data = get(selectedTemplate, "graph_report");
  const dispatch = useDispatch();
  const locationId = get(selectedTemplate, "template.location_id");
  const [address, setAddress] = useState();

  const getLocation = (locationId) => {
    setLoading(true);
    dispatch(fetchScopeNodeHierarchy("LOCATION", locationId))
      .then((result) => {
        setAddress(get(result, "name"));
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (locationId) {
      getLocation(locationId);
    }
  }, [locationId]);

  return (
    <>
      <GraphHeader
        filter={filter}
        setLoading={setLoading}
        selectedTemplate={selectedTemplate}
        onChangeParams={onChangeParams} />

      <Row id="content-container">
        <GraphGrid
          type="time"
          graphId={1}
          stats={get(data, "on_off_graph", [])}
          label={"On / Off / Idle"}
          statistics={[
            {
              value: getTransformedMinutes(
                get(selectedTemplate, "meta.total_off_hours") ? round(get(selectedTemplate, "meta.total_off_hours")) : 0
              ),
              label: "Off Hours",
            },
            {
              value: getTransformedMinutes(
                get(selectedTemplate, "meta.total_idle_hours") ? round(get(selectedTemplate, "meta.total_idle_hours")) : 0
              ),
              label: "Idle  Hours",
            },
            {
              value: getTransformedMinutes(
                get(selectedTemplate, "meta.total_working_hours") ? round(get(selectedTemplate, "meta.total_working_hours")) : 0
              ),
              label: "Working Hours",
            },
          ]}
               selectedTemplate={selectedTemplate}
           filter={filter}
        />
        <Divider />
        <GraphGrid
          graphId={2}
          type="time"
          label={"Count"}
          stats={sortBy(slice(get(data, "count_graph", [])), "date")}
          statistics={[
            {
              value: get(selectedTemplate, "meta.total_counts") ? round(get(selectedTemplate, "meta.total_counts")) : 0,
              label: "Count",
            },
          ]}
               selectedTemplate={selectedTemplate}
           filter={filter}
        />
        <Divider />
        <GraphGrid
          graphId={3}
          type="time"
          label={"Machining time"}
          stats={sortBy(slice(get(data, "machining_time_graph", [])), "date")}
          statistics={[
            {
              value: `${get(selectedTemplate, "meta.avg_machining_time") ? round(get(selectedTemplate, "meta.avg_machining_time")) : 0} Sec`,
              label: "Machining time",
            },
          ]}
               selectedTemplate={selectedTemplate}
           filter={filter}
        />
        <GraphGrid
          graphId={4}
          type="time"
          label={"Non-Machining time"}
          stats={sortBy(slice(get(data, "non_machinig_time_graph", [])), "date")}
          statistics={[
            {
              value: `${get(selectedTemplate, "meta.avg_non_machining_time") ? round(get(selectedTemplate, "meta.avg_non_machining_time")) : 0} Sec`,
              label: "Non-Machining time",
            },
          ]}
               selectedTemplate={selectedTemplate}
           filter={filter}     
        />
        <Divider />
        {get(data, "power_consumption_graph") && (
          <GraphGrid
            type="time"
            graphId={5}
            label={"Power Consumption"}
            stats={get(data, "power_consumption_graph", [])}
            statistics={[
              {
                value: `${get(
                  selectedTemplate,
                  "meta.total_power_consumption"
                ) ? round(get(
                  selectedTemplate,
                  "meta.total_power_consumption"
                )) : 0} Kwh`,
                label: "Power Consumption",
              },
            ]}
                 selectedTemplate={selectedTemplate}
           filter={filter}
          />
        )}
      </Row>
    </>
  );
};

export default CNCGraphSection;
